export default "__VITE_ASSET__B9dR1fb0__"